import {
  faBackspace,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Form, Row, Space } from "antd";
import { Button, Container } from "components/ui";
import { useParams } from "react-router-dom";
import useCitiesAddContext from "../services/citiesAddContext";
import { Field } from "components/form";

const CitiesAdd = () => {
  const { id } = useParams();

  const {
    state: { form },
    actions: { onFinish, handleDelete },
  } = useCitiesAddContext();
  return (
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Row gutter={[20, 20]}>
        <Col xs={24} md={19}>
          <Container padding={false} background={false}>
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <Container overflow={false} height={false}>
                <Row gutter={[20, 0]}>
                  <Col xs={12}>
                    <Field
                      form={form}
                      title="Nomi"
                      name="name"
                      type="input"
                      required
                      language
                    />
                  </Col>
                </Row>
              </Container>
            </Space>
          </Container>
        </Col>
        <Col xs={24} md={5}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Button
              icon={<FontAwesomeIcon icon={faEdit} />}
              block
              type="primary"
              style={{ backgroundColor: "#1EB53A" }}
              htmlType="submit"
            >
              Saqlash
            </Button>
            <Button
              icon={<FontAwesomeIcon icon={id ? faTrash : faBackspace} />}
              block
              type={id ? "primary" : "default"}
              onClick={handleDelete}
            >
              {id ? "O'chirish" : "Bekor qilish"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CitiesAdd;
